"use strict";
// TODO: This component should really be combined with common/CurrencyPicker
// We should make CurrencyPicker take a 'type' prop
// Where if type == dropdown, render dropdown select
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRedux = require("react-redux");

var _UIDropdownSelect = _interopRequireDefault(require("UIComponents/dropdown/UIDropdownSelect"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _ActiveCurrencyCodeActions = require("pricing-pages-unified-ui/actions/ActiveCurrencyCodeActions");

var CurrencySelector = function CurrencySelector(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      availableCurrencies = _ref.availableCurrencies,
      onUpdateActiveCurrencyCode = _ref.onUpdateActiveCurrencyCode;

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    onUpdateActiveCurrencyCode(value);
  };

  var getCurrencyOptions = function getCurrencyOptions() {
    return availableCurrencies.map(function (availableCurrency) {
      return {
        text: availableCurrency + " (" + _I18n.default.currencySymbols[availableCurrency].symbol + ")",
        value: availableCurrency
      };
    });
  };

  var shouldShowSelector = availableCurrencies && availableCurrencies.length > 1;

  if (!shouldShowSelector) {
    return _react.default.createElement("span", {
      style: {
        minHeight: '40px'
      }
    });
  }

  return _react.default.createElement(_UIDropdownSelect.default, {
    className: "display-inline-block",
    options: getCurrencyOptions(),
    onChange: handleChange,
    value: activeCurrencyCode
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    availableCurrencies: (0, _CurrencySelectors.availableCurrenciesSelector)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onUpdateActiveCurrencyCode: function onUpdateActiveCurrencyCode(currency) {
      return dispatch((0, _ActiveCurrencyCodeActions.updateActiveCurrencyCode)({
        currency: currency
      }));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencySelector);

exports.default = _default;
module.exports = exports.default;